import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="clear-input-button"
export default class extends Controller {
    static targets = ['input', 'clearButton']

    inputChanged() {
        this.toggleClearButton()
    }

    clear(event) {
        // Prevent the dropdown from closing when clicking the clear button
        event.stopPropagation()

        this.inputTarget.value = ''
        this.inputTarget.focus()
        this.toggleClearButton()

        // Dispatch input event to trigger any other listeners (like list-search)
        this.inputTarget.dispatchEvent(new Event('input', { bubbles: true }))
    }

    toggleClearButton() {
        const hasValue = this.inputTarget.value.length > 0
        this.clearButtonTarget.style.display = hasValue ? 'block' : 'none'
    }
}
